import React from 'react';
import ReactDOM from 'react-dom';
import Immutable from 'immutable';
import Dfp from './Dfp';
import TopTags from './TopTags';
import {interactiveQuestions} from '../sites/she.com/js/interactiveQuestions';
import 'whatwg-fetch';
import Shegallery from "./Shegallery";
// import update from 'react-addons-update';

class Article extends React.Component {

    constructor(props) {
        super(props)

        let tempShowInteractive = [];

        interactiveQuestions.map((item,idx) => {
            tempShowInteractive[idx] = true;
        })

        Shegallery(0);
        this.state = {
            page:1,
            firstPostURL:window.location.href,
            firstPostTitle:document.title,
            firstAdsInit:false,
            curPostId:props.postId,
            curURL:'',
            dataList:Immutable.List([]),
            hasNextPage:parseInt(document.querySelector('meta[name="nextPage"]').content),
            isNextPageLoading:false,
            showInteractive: tempShowInteractive,
            answerClicked: false,
            hottestArticles: '',
            tagCloud: '',
            pinBottomInit:false,
            tagList: []
        }

        this.isMobile = navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i);
        this.pagePlacement = document.querySelector('meta[name="page"]').content;
        this.parentCategory = document.querySelector('meta[name="category"]')? document.querySelector('meta[name="category"]').content : '';
        // For pintag
        this.isPinTag = false;
        this.pinTagTerm = document.querySelector('meta[name="term"]')? document.querySelector('meta[name="term"]').content : '';
        if (this.pagePlacement == 'single' && this.pinTagTerm != ''){
            this.isPinTag = true;
        }

        let popularTag = document.getElementById('popular-tag') && document.getElementById('popular-tag').dataset? document.getElementById('popular-tag').dataset.tags : '';
        this.tagDataset = popularTag? JSON.parse(popularTag) : [];

        this.dfpList = [];
        this.dfpCount = 0;
        this._loadMoreRows = this._loadMoreRows.bind(this);
        this.isScrolledIntoView = this.isScrolledIntoView.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.dfpUpdate = this.dfpUpdate.bind(this);
        this.dfpReady = this.dfpReady.bind(this);
        this.expandContent = this.expandContent.bind(this);
        this.getTags = this.getTags.bind(this);
    }

    dfpUpdate(){
        this.dfpCount++;
    }

    dfpReady(adunit){
        this.dfpList.push(adunit)
        if(this.dfpCount == this.dfpList.length){
            googletag.pubads().refresh(this.dfpList);
            this.dfpCount = 0;
            this.dfpList = [];
        }
    }

    componentWillUnmount(){
        window.removeEventListener('scroll', this.handleScroll);
    }

    componentDidMount(){
        const { theme } = this.props;
        const { tagList } = this.state;
        let that = this;

        let title = document.querySelector('meta[property="og:title"]').content;
        title = title.substring(0, title.indexOf(' - '));

        this.getTags(this.tagDataset);

        const catid= document.querySelector('meta[name="catId"]').content;
        const site= document.querySelector('meta[name="baseURL"]').content;
        if(!this.state.firstAdsInit){
            const leaderboardElement = document.getElementById(window.innerWidth > 700 ? 'article-ads-leaderboard' : 'article-ads-leaderboard-mobile');
            if(leaderboardElement){
                if (catid ==7287 && site=='https://www.shemom.com'){
                    ReactDOM.render(
                        <Dfp
                            dfpReady={this.dfpReady}
                            dfpUpdate={this.dfpUpdate}
                            adUnit={ theme+"_article_NestleMom_970x90" }
                            sizes={[[970,90],[970,550],[970,250],[728,90],[728,180],[320,50],[320,100],[300,250]]}
                            sizeMapping={ [
                                {viewport: [970, 0], sizes:[[728, 90],[728, 180],[970, 90],[970,250]]},
                                {viewport: [0, 0], sizes:[[320, 50],[320, 100],[300,250]]}
                            ]}
                        />,
                        leaderboardElement
                    );
                }else if ((catid==7289 || catid==7339 || catid==7338) && site=='https://www.shemom.com'){
                    ReactDOM.render(
                        <Dfp
                            dfpReady={this.dfpReady}
                            dfpUpdate={this.dfpUpdate}
                            adUnit={ theme+"_article_NestleBB_970x90" }
                            sizes={[[970,90],[970,550],[970,250],[728,90],[728,180],[320,50],[320,100],[300,250]]}
                            sizeMapping={ [
                                {viewport: [970, 0], sizes:[[728, 90],[728, 180],[970, 90],[970,250]]},
                                {viewport: [0, 0], sizes:[[320, 50],[320, 100],[300,250]]}
                            ]}
                        />,
                        leaderboardElement
                    );
                }else{
                    ReactDOM.render(
                        <Dfp
                            dfpReady={this.dfpReady}
                            dfpUpdate={this.dfpUpdate}
                            adUnit={ theme+"_article_ATF_970x90" }
                            sizes={[[970,90],[970,550],[970,250],[728,90],[728,180],[320,50],[320,100],[300,250]]}
                            sizeMapping={ [
                                {viewport: [970, 0], sizes:[[728, 90],[728, 180],[970, 90],[970,250]]},
                                {viewport: [0, 0], sizes:[[320, 50],[320, 100],[300,250]]}
                            ]}
                        />,
                        leaderboardElement
                    );
                }

            }
            if(document.getElementById('article-ads-lrec')){
                if (catid ==7287 && site=='https://www.shemom.com'){
                    ReactDOM.render(
                        <div className="ad_300x250 text-center">
                            {
                                this.isMobile? <div className="popular-tag-mobile">
                                    <TopTags theme={theme} page={this.pagePlacement} position={'side'} catName={this.parentCategory} tagList={tagList} />
                                </div>:''
                            }
                            <Dfp
                                dfpReady={this.dfpReady}
                                dfpUpdate={this.dfpUpdate}
                                adUnit={ theme+"_article_NestleMom_300x250" }
                                // adUnit={ "she.com_article_ATF_300x250" }
                                sizes={[[300,250],[300,600]]}
                            />
                        </div>,
                        document.getElementById('article-ads-lrec')
                    );
                }else if ((catid==7289 || catid==7339 || catid==7338) && site=='https://www.shemom.com'){
                    ReactDOM.render(
                        <div className="ad_300x250 text-center">
                            {
                                this.isMobile? <div className="popular-tag-mobile">
                                    <TopTags theme={theme} page={this.pagePlacement} position={'side'} catName={this.parentCategory} tagList={tagList} />
                                </div>:''
                            }
                            <Dfp
                                dfpReady={this.dfpReady}
                                dfpUpdate={this.dfpUpdate}
                                adUnit={ theme+"_article_NestleBB_300x250" }
                                // adUnit={ "she.com_article_ATF_300x250" }
                                sizes={[[300,250],[300,600]]}
                            />
                        </div>,
                        document.getElementById('article-ads-lrec')
                    );
                }else{
                    ReactDOM.render(
                        <div className="ad_300x250 text-center">
                            {
                                this.isMobile? <div className="popular-tag-mobile">
                                    <TopTags theme={theme} page={this.pagePlacement} position={'side'} catName={this.parentCategory} tagList={tagList} />
                                </div>:''
                            }
                            <Dfp
                                dfpReady={this.dfpReady}
                                dfpUpdate={this.dfpUpdate}
                                adUnit={ theme+"_article_ATF_300x250" }
                                // adUnit={ "she.com_article_ATF_300x250" }
                                sizes={[[300,250],[300,600]]}
                            />
                        </div>,
                        document.getElementById('article-ads-lrec')
                    );
                }

            }


            // if(document.getElementById('inpost_related_articles')){
            // 	ReactDOM.render(
            // 		<div>
            // 			hihihihi
            // 		</div>,
            // 		document.getElementById('inpost_related_articles')
            // 	);
            // }

            interactiveQuestions.map((q,idx) => {
                if(document.getElementById('interactive-article-'+(idx+1))){

                    if(q.type=='banner') {
                        ReactDOM.render(
                            <div class="container banner">
                                <div className="close" onClick={() => {
                                    document.getElementById('interactive-article-'+(idx+1)).classList.add('closed');
                                    dataLayer.push({
                                        event: 'interactive-article-click',
                                        interactiveArticleAction: 'interactive_article_close',
                                        interactiveArticleLabel: q.message
                                    })}
                                }></div>


                                <div className="img1" onClick={() => {

                                    dataLayer.push({
                                        event: 'interactive-article-click',
                                        interactiveArticleAction: 'interactive_article_click',
                                        interactiveArticleLabel: q.url1
                                    })

                                }}>
                                    <a target={ q.url1 ? '_blank' : '' } href={ q.url1 ? q.url1+'?utm_source='+that.getUTMSource(theme)+'&utm_medium=referral&utm_campaign=interactive_article&utm_term='+q.utm_term+'&utm_content='+title : 'javascript:;'}>
                                        <img src={'/assets/img/'+q.img1} />
                                    </a>
                                </div>

                            </div>
                            , document.getElementById('interactive-article-'+(idx+1)))
                    }else{
                        ReactDOM.render(
                            <div class="container">
                                <div className="close" onClick={() => {
                                    document.getElementById('interactive-article-'+(idx+1)).classList.add('closed');
                                    dataLayer.push({
                                        event: 'interactive-article-click',
                                        interactiveArticleAction: 'interactive_article_close',
                                        interactiveArticleLabel: q.message
                                    })}
                                }></div>

                                <div className="icon"><img src={'/assets/img/'+q.icon} /></div>
                                <div className="message-box">
                                    <div class="account">{q.account}</div>
                                    <div class="message">{q.message}</div>
                                </div>
                                <div className="img1" onClick={() => {
                                    if(!this.state.answerClicked && !q.url1) {
                                        dataLayer.push({
                                            event: 'interactive-article-click',
                                            interactiveArticleAction: 'interactive_article_click',
                                            interactiveArticleLabel: q.des1
                                        });
                                        document.querySelector('#interactive-article-'+(idx+1)+' .img2').classList.add('fade');
                                        document.querySelector('#interactive-article-'+(idx+1)+' .message-box').classList.add('fade');

                                        setTimeout(() => {
                                            document.querySelector('#interactive-article-'+(idx+1)+' .message').innerHTML = '多謝你的意見!';
                                            document.querySelector('#interactive-article-'+(idx+1)+' .message-box').classList.remove('fade');
                                        }, 200)

                                        this.setState({answerClicked: true});
                                        setTimeout(() => {
                                            document.getElementById('interactive-article-'+(idx+1)).classList.add('closed');
                                        }, 2000)
                                    }else if(!this.state.answerClicked){
                                        dataLayer.push({
                                            event: 'interactive-article-click',
                                            interactiveArticleAction: 'interactive_article_click',
                                            interactiveArticleLabel: q.url1
                                        })
                                    }
                                }}>
                                    <a target={ q.url1 ? '_blank' : '' } href={ q.url1 ? q.url1+'?utm_source='+that.getUTMSource(theme)+'&utm_medium=referral&utm_campaign=interactive_article&utm_term=beauty&utm_content='+title : 'javascript:;'}>
                                        <img src={'/assets/img/'+q.img1} />
                                        <div className="des">{q.des1}</div>
                                    </a>
                                </div>

                                <div className="img2" onClick={() => {
                                    if(!this.state.answerClicked && !q.url2) {
                                        dataLayer.push({
                                            event: 'interactive-article-click',
                                            interactiveArticleAction: 'interactive_article_click',
                                            interactiveArticleLabel: q.des2
                                        });
                                        document.querySelector('#interactive-article-'+(idx+1)+' .img1').classList.add('fade');
                                        document.querySelector('#interactive-article-'+(idx+1)+' .message-box').classList.add('fade');

                                        setTimeout(() => {
                                            document.querySelector('#interactive-article-'+(idx+1)+' .message').innerHTML = '多謝你的意見!';
                                            document.querySelector('#interactive-article-'+(idx+1)+' .message-box').classList.remove('fade');
                                        }, 200)

                                        this.setState({answerClicked: true});
                                        setTimeout(() => {
                                            document.getElementById('interactive-article-'+(idx+1)).classList.add('closed');
                                        }, 2000)
                                    }else if(!this.state.answerClicked){
                                        dataLayer.push({
                                            event: 'interactive-article-click',
                                            interactiveArticleAction: 'interactive_article_click',
                                            interactiveArticleLabel: q.url2
                                        })
                                    }
                                }}>
                                    <a target={ q.url2 ? '_blank' : '' } href={ q.url2 ? q.url2+'?utm_source='+that.getUTMSource(theme)+'&utm_medium=referral&utm_campaign=interactive_article&utm_term=beauty&utm_content='+title : 'javascript:;'}>
                                        <img src={'/assets/img/'+q.img2} />
                                        <div className="des">{q.des2}</div>
                                    </a>
                                </div>
                            </div>
                            , document.getElementById('interactive-article-'+(idx+1)))
                    }
                }
            })

            //mobile
            document.querySelector('#first-article .btn-content-more').onclick = this.expandContent;
            document.getElementById('fb-share').onclick = this.shareURL;
            document.getElementById('weibo-share').onclick = this.shareURL;
            document.getElementById('whatsapp-share').onclick = this.shareURL;
            document.getElementById('line-share').onclick = this.shareURL;
            //desktop
            document.getElementById('fb-desktop-share').onclick = this.shareURL;
            document.getElementById('weibo-desktop-share').onclick = this.shareURL;
            document.getElementById('whatsapp-desktop-share').onclick = this.shareURL;
            document.getElementById('copylink-desktop-share').onclick = this.shareURL;
            this.setState({ firstAdsInit:true });
        }

        window.addEventListener('scroll', this.handleScroll);
    }

    isScrolledIntoView(elm,scrolltop){

        let docViewTop = scrolltop;
        let docViewBottom = docViewTop + ( window.outerHeight==0 ? window.innerHeight : window.outerHeight );

        let elemTop = (elm.getBoundingClientRect().top-( elm.id=='article-loadmore' ? 250 : 0))+docViewTop;
        let elemBottom = elemTop + elm.getBoundingClientRect().height-( elm.id=='article-loadmore' ? 250 : 0);

        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    }

    isScrolledInsideView(elm,scrolltop){
        if(typeof elm == 'undefined') return;
        let docViewTop = scrolltop;
        let docViewBottom = docViewTop + ( window.outerHeight==0 ? window.innerHeight : window.outerHeight );

        let elemTop = elm.getBoundingClientRect().top+docViewTop;
        let elemBottom = elemTop + elm.getBoundingClientRect().height;

        return ((docViewBottom <= elemBottom) && (docViewTop >= elemTop));
    }

    handleScroll(evnt){
        const { isNextPageLoading, hasNextPage, dataList, lastScrollTop, firstPostURL, firstPostTitle , curURL } = this.state;

        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

        if(this.isScrolledIntoView(document.getElementById('article-loadmore'),scrollTop) && !isNextPageLoading){
            this._loadMoreRows()
            this.setState({
                isNextPageLoading:true
            });

            if(document.getElementById('loading-bar') && hasNextPage){
                document.getElementById('loading-bar').className = '';
            }
        }

        if(document.querySelectorAll('.interactive-article')){
            let tmpElm = document.querySelectorAll('.interactive-article')
            for(let i=0; i<tmpElm.length; i++){
                if( this.isScrolledIntoView(tmpElm[i],scrollTop)){
                    let elmId = tmpElm[i].id.replace( /^\D+/g, '');
                    if(this.state.showInteractive[elmId-1]){
                        dataLayer.push({event: 'interactive-article-click', interactiveArticleAction: 'interactive_article_view', interactiveArticleLabel: interactiveQuestions[elmId-1].message})
                        tmpElm[i].classList.add('show');
                        let tempShowInteractive = this.state.showInteractive;

                        tempShowInteractive[elmId-1] = false;

                        this.setState({
                            showInteractive: tempShowInteractive
                        });
                    }
                }
            }
        }

        if(document.querySelectorAll('.article-content-detail')){
            let tmpElm = document.querySelectorAll('.article-content-detail');
            for(let i=0; i<tmpElm.length; i++){
                if( this.isScrolledIntoView(tmpElm[i],scrollTop) || this.isScrolledInsideView(tmpElm[i],scrollTop) ){
                    let tmpArticleIdx = parseInt(tmpElm[i].id.replace('article-content-detail',''));
                    let tmpURL = dataList.get(tmpArticleIdx).url;
                    let tmpTitle = dataList.get(tmpArticleIdx).post_title;
                    let tmpAuthorName = dataList.get(tmpArticleIdx).author_name;
                    let ga_url_append = (dataList.get(tmpArticleIdx).pin_bottom_post_id != null) ? 'pin' : 'exp';

                    if(curURL != tmpURL){
                        history.pushState(null, null, tmpURL);
                        document.title = tmpTitle;
                        this.setState( { curURL:tmpURL } );
                        const { curPostId } = this.state;
                        //setup GTM
                        // dataLayer.push({ virtualPageTitle:firstPostTitle,virtualPageURL:firstPostURL.replace(/^.*\/\/[^\/]+/, '')+'more-'+(tmpArticleIdx+1),event:'VirtualPageview'  });

                        // change to auto-expand when scrolling into view
                        dataLayer.push({ 'author':tmpAuthorName ,virtualPageTitle:tmpTitle, virtualPageURL:tmpURL.replace(/^.*\/\/[^\/]+/, '')+ga_url_append,event:'VirtualPageview'  });
                        if(window.Analytics){
                            window.Analytics.push({path: window.location.pathname, action: 'view', objectId: curPostId});
                        }
                        setTimeout(()=>{
                            instgrm.Embeds.process()
                        },300)

                    }
                    break;
                }
            }
        }

        if(this.isScrolledIntoView(document.getElementById('first-article'),scrollTop) || this.isScrolledInsideView(document.getElementById('first-article'),scrollTop)){
            if(curURL != firstPostURL){
                history.pushState(null, null, firstPostURL);
                document.title = firstPostTitle;
                this.setState( { curURL:firstPostURL } );
                //setup GTM
                //console.log('more-0');
                //  dataLayer.push({ virtualPageTitle:document.title,virtualPageURL:firstPostURL.replace(/^.*\/\/[^\/]+/, '')+'more-0',event:'VirtualPageview'  });
            }
        }


        if(document.getElementById('share-buttons')){
            setTimeout(function(){
                document.getElementById('share-buttons').className = 'show';
            },500);
        }

        // interactiveQuestions.map((q,idx) => {
        //     if (document.getElementById('interactive-article-' + (idx + 1)) && this.state.showInteractive[idx]) {
        //         setTimeout(function(){
        //             document.getElementById('interactive-article-' + (idx + 1)).classList.add('show');
        //             dataLayer.push({event: 'interactive-article-click', interactiveArticleAction: 'interactive_article_view', interactiveArticleLabel: q.message})
        //         }, /* .url1 ? 500 :*/ 500);
        //         let tempShowInteractive = this.state.showInteractive;
        //
        // 		tempShowInteractive[idx] = false;
        //
        //         this.setState({
        //             showInteractive: tempShowInteractive
        // 		});
        //     }
        // });

    }

    _loadMoreRows() {
        const { pinBottomInit, hottestArticles, firstPostTitle, dataList,page, isNextPageLoading, hasNextPage, curPostId } = this.state
        const { theme, catId, baseurl } = this.props
        let that = this;
        let googletag = window.googletag

        let params = {
            id:curPostId,
            offset:1,
            category:catId
        };


        if(hasNextPage==0){
            if(document.getElementById('loading-bar')){
                document.getElementById('loading-bar').className = 'done';
            }
            return;
        }

        let formData = new FormData();
        for (var k in params) {
            if(params.hasOwnProperty(k)){
                formData.append(k, params[k]);
            }
        }

        var queryPath = baseurl+'/wp-json/she-rest-api/getPinBottoms?postId='+document.querySelector('meta[name="postId"]').content;
        var queryMethod = "GET";
        if (!pinBottomInit && that.isPinTag) {
            queryPath = baseurl+'/wp-json/she-rest-api/getPinTagByAPI?term='+that.pinTagTerm;
            queryMethod = "POST";
        }

        if (!pinBottomInit) {
            fetch(queryPath,{
                method:queryMethod,
            }).then(function(res){
                return res.json();
            }).then(function(response){
                googletag.cmd.push(function() {
                    googletag.pubads().setTargeting("brand", "");
                });
                if(response.items.length){

                    const min = 0;
                    const max = response.items.length;
                    const rand = min + Math.floor(Math.random() * (max - min));

                    let arr = response.items;
                    let pat = /setTargeting[(]\"brand\", \"([\S]+)\"[)];/gi;
                    let checkTargeting = pat.exec(arr[0].post_content);
                    //console.log(that);
                    if(checkTargeting){
                        googletag.cmd.push(function() {
                            googletag.pubads().setTargeting("brand", checkTargeting[1]);
                        });
                    }
                    let output = [];
                    output.push(arr[rand]);

                    that.setState({
                        dataList:dataList.concat(Immutable.List(output)),
                        pinBottomInit:true,
                        hasNextPage: true,
                        isNextPageLoading:false,
                        page:page+1,
                        // curPostId:arr[0].ID
                    },function(){
                        document.dispatchEvent(new Event('loadNextArticle'));
                    });

                    // In Post Ad for shop.she.com
                    if(document.getElementsByClassName('online-store-nav').length > 0){
                        let length = document.getElementsByClassName('online-store-nav').length
                        let el = document.getElementsByClassName('online-store-nav')[length-1]
                        if(el.querySelectorAll('#buyNowLink')[0].href.indexOf('utm_content') == -1){
                            el.querySelectorAll('#buyNowLink')[0].href += ('&utm_content=' + document.title)
                            el.querySelectorAll('.online-store-nav-close-btn')[0].addEventListener('click', function() {
                                el.style.display = 'none';
                            })
                        }
                    }

                } else {
                    that.setState({
                        pinBottomInit:true,
                    },function(){
                        document.dispatchEvent(new Event('loadNextArticle'));
                        that._loadMoreRows();
                    });
                }

                if(document.getElementById('loading-bar')){
                    document.getElementById('loading-bar').className = 'done';
                }


                if(window.splashAd)
                    googletag.pubads().refresh([window.splashAd]);

            }).catch(function(error){
                console.log(error);
            });
        } else {
            fetch(baseurl + '/wp-json/she-rest-api/getNextPrevArticle/', {
                method: "POST",
                body: formData
            }).then(function (res) {
                return res.json();
            }).then(function (response) {
                googletag.cmd.push(function () {
                    googletag.pubads().setTargeting("brand", "");
                });
                if (response.items.length) {

                    let arr = response.items;
                    let pat = /setTargeting[(]\"brand\", \"([\S]+)\"[)];/gi;
                    let checkTargeting = pat.exec(arr[0].post_content);
                    //console.log(that);
                    if (checkTargeting) {
                        googletag.cmd.push(function () {
                            googletag.pubads().setTargeting("brand", checkTargeting[1]);
                        });
                    }
                    console.log("Load more article with post of  ", arr);

                    that.setState({
                        dataList: dataList.concat(Immutable.List(arr)),
                        hasNextPage: response.next,
                        isNextPageLoading: false,
                        page: page + 1,
                        curPostId: arr[0].ID
                    }, function () {
                        document.dispatchEvent(new Event('loadNextArticle'));

                        // In Post Ad for shop.she.com
                        if(document.getElementsByClassName('online-store-nav').length > 0){
                            let length = document.getElementsByClassName('online-store-nav').length
                            let el = document.getElementsByClassName('online-store-nav')[length-1]
                            if(el.querySelectorAll('#buyNowLink')[0].href.indexOf('utm_content') == -1){
                                el.querySelectorAll('#buyNowLink')[0].href += ('&utm_content=' + document.title)
                                el.querySelectorAll('.online-store-nav-close-btn')[0].addEventListener('click', function() {
                                    el.style.display = 'none';
                                })
                            }
                        }
                    });
                }

                if (document.getElementById('loading-bar')) {
                    document.getElementById('loading-bar').className = 'done';
                }

                Shegallery(1);
                if (window.splashAd)
                    googletag.pubads().refresh([window.splashAd]);

            }).catch(function (error) {
                console.log(error);
            });
        }
    }

    shareURL(evnt){
        let elm = evnt.currentTarget;
        let shareType = elm.id.replace('-share','');
        let isMobile = navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i)
        let stitle = document.title;
        let surl = window.location.href;

        if(shareType=='fb' || shareType=='fb-desktop'){
            if (stitle == '')
                if (surl != '') {
                    let vmark = '?';
                    if (surl.indexOf("?") > -1) {
                        vmark = '&';
                    }
                    surl = surl + vmark + 'utm_source=facebook_share&utm_medium=referral';
                }
            if (surl == '') surl = window.location + "?" + 'utm_source=facebook_share&utm_medium=referral';
            stitle = encodeURIComponent(stitle);
            surl = escape(surl);
            let _u = 'http://www.facebook.com/sharer.php?' + '&u=' + surl;

            if(dataLayer)
                dataLayer.push({event: 'share', virtualPageURL: surl, sharedMedia: 'facebook'});

            window.open(_u, 'fbsharer', "status=no, toolbar=no, menubar=no, scrollbars=no, location=no, directories=no, width=626, height=335");
        }else if(shareType=='weibo' || shareType=='weibo-desktop'){
            let tmpShareurl = 'http://v.t.sina.com.cn/share/share.php?title=' + encodeURIComponent(stitle) + '&url=' + escape(surl);
            window.open(tmpShareurl, 'weibo share', "status=no, toolbar=no, menubar=no, scrollbars=no, location=no, directories=no, width=626, height=335");
        }else if(shareType=='fbmessenger'){
            if(dataLayer)
                dataLayer.push({event: 'share', virtualPageURL: surl, sharedMedia: 'fbmessenger'});
            setTimeout(function(){
                window.location.href = "fb-messenger://share/?link="+escape(surl);
            },300);
        }else if(shareType=='whatsapp' || shareType=='whatsapp-desktop'){
            let msg = stitle+'\n'+surl;
            if(isMobile){
                if(dataLayer)
                    dataLayer.push({event: 'share', virtualPageURL: surl, sharedMedia: 'whatsapp'});
                setTimeout(function(){
                    window.location.href = "whatsapp://send?text="+encodeURIComponent(msg);
                },300);
            } else {
                if(dataLayer)
                    dataLayer.push({event: 'share', virtualPageURL: surl, sharedMedia: 'whatsapp'});
                setTimeout(function(){
                    // window.location.href = "https://wa.me/?text="+encodeURIComponent(msg);
                    window.open("https://wa.me/?text="+encodeURIComponent(msg));
                },300);
            }
        }else if(shareType=='copylink' || shareType=='copylink-desktop'){
            let msg = decodeURIComponent(surl);

            if(dataLayer)
                dataLayer.push({event: 'share', virtualPageURL: surl, sharedMedia: 'copylink'});
            setTimeout(function(){
                let dummy = document.createElement("textarea");
                document.body.appendChild(dummy);
                dummy.value = msg;
                dummy.select();
                document.execCommand("copy");
                document.body.removeChild(dummy);
            },600);
        }else{
            let msg = stitle+' '+surl;
            if(dataLayer)
                dataLayer.push({event: 'share', virtualPageURL: surl, sharedMedia: 'line'});
            setTimeout(function(){
                window.location.href = "http://line.me/R/msg/text/?"+encodeURIComponent(msg);
            },300);
        }

    }

    // not in use
    expandContent(evnt, authorName){
        let elm = evnt.target.parentNode;
        let tmpCurURL = window.location.href;
        const { curPostId } = this.state;

        elm.style.display = 'none';
        if(typeof elm.previousSibling.className != 'undefined'){
            elm.previousSibling.className = elm.previousSibling.className + ' expand';
        }else{
            elm.previousSibling.previousSibling.className = elm.previousSibling.previousSibling.className + ' expand';
        }


        dataLayer.push({ 'author':authorName ,virtualPageTitle:document.title,virtualPageURL:tmpCurURL.replace(/^.*\/\/[^\/]+/, '')+'exp',event:'VirtualPageview'  });

        if(window.Analytics){
            window.Analytics.push({path: window.location.pathname, action: 'view', objectId: curPostId});
        }

        setTimeout(()=>{
            instgrm.Embeds.process()
        },300)
    }

    renderHtml(item){
        let html = item.post_content;
        let tmp = html;
        let extractscript=html.match(/<script[^>]*name=\"inpost_ads\">(.+)<\/script>/gi);
        let that = this;
        let title = document.querySelector('meta[property="og:title"]').content;
        title = title.substring(0, title.indexOf(' - '));
        const { theme } = this.props;

        if(extractscript){
            for(let i=0; i<extractscript.length;i++){
                tmp = tmp.replace(extractscript[i],"");
            }

            setTimeout(function(){
                for(let j=0; j<extractscript.length;j++){
                    window.eval(extractscript[j].replace('<script name="inpost_ads">','').replace('</script>',''));
                }
            },300);
        }
        interactiveQuestions.map((q,idx) => {
            if(document.getElementById('interactive-article-'+(idx+1))) {
                if(q.type=='banner') {
                    ReactDOM.render(
                        <div class="container banner">
                            <div className="close" onClick={() => {
                                document.getElementById('interactive-article-'+(idx+1)).classList.add('closed');
                                dataLayer.push({
                                    event: 'interactive-article-click',
                                    interactiveArticleAction: 'interactive_article_close',
                                    interactiveArticleLabel: q.message
                                })}
                            }></div>


                            <div className="img1" onClick={() => {

                                dataLayer.push({
                                    event: 'interactive-article-click',
                                    interactiveArticleAction: 'interactive_article_click',
                                    interactiveArticleLabel: q.url1
                                })

                            }}>
                                <a target={ q.url1 ? '_blank' : '' } href={ q.url1 ? q.url1+'?utm_source='+that.getUTMSource(theme)+'&utm_medium=referral&utm_campaign=interactive_article&utm_term='+q.utm_term+'&utm_content='+title : 'javascript:;'}>
                                    <img src={'/assets/img/'+q.img1} />
                                </a>
                            </div>

                        </div>
                        , document.getElementById('interactive-article-'+(idx+1)))
                }else{

                    ReactDOM.render(
                        <div class="container">
                            <div className="close" onClick={() => {
                                document.getElementById('interactive-article-' + (idx + 1)).classList.add('closed');
                                dataLayer.push({
                                    event: 'interactive-article-click',
                                    interactiveArticleAction: 'interactive_article_close',
                                    interactiveArticleLabel: q.message
                                })
                            }
                            }></div>
                            <div className="icon"><img src={'/assets/img/' + q.icon}/></div>
                            <div className="message-box">
                                <div class="account">{q.account}</div>
                                <div class="message">{q.message}</div>
                            </div>
                            <div className="img1" onClick={() => {
                                if (!this.state.answerClicked && !q.url1) {
                                    dataLayer.push({
                                        event: 'interactive-article-click',
                                        interactiveArticleAction: 'interactive_article_click',
                                        interactiveArticleLabel: q.des1
                                    });
                                    document.querySelector('#interactive-article-' + (idx + 1) + ' .img2').classList.add('fade');
                                    document.querySelector('#interactive-article-' + (idx + 1) + ' .message-box').classList.add('fade');

                                    setTimeout(() => {
                                        document.querySelector('#interactive-article-' + (idx + 1) + ' .message').innerHTML = '多謝你的意見!';
                                        document.querySelector('#interactive-article-' + (idx + 1) + ' .message-box').classList.remove('fade');
                                    }, 200)

                                    this.setState({answerClicked: true});
                                    setTimeout(() => {
                                        document.getElementById('interactive-article-' + (idx + 1)).classList.add('closed');
                                    }, 2000)
                                } else if (!this.state.answerClicked) {
                                    dataLayer.push({
                                        event: 'interactive-article-click',
                                        interactiveArticleAction: 'interactive_article_click',
                                        interactiveArticleLabel: q.url1
                                    })
                                }
                            }}>
                                <a target={q.url1 ? '_blank' : ''}
                                   href={q.url1 ? q.url1 + '?utm_source=' + that.getUTMSource(theme) + '&utm_medium=referral&utm_campaign=interactive_article&utm_term=beauty&utm_content=' + title : 'javascript:;'}>
                                    <img src={'/assets/img/' + q.img1}/>
                                    <div className="des">{q.des1}</div>
                                </a>
                            </div>

                            <div className="img2" onClick={() => {
                                if (!this.state.answerClicked && !q.url2) {
                                    dataLayer.push({
                                        event: 'interactive-article-click',
                                        interactiveArticleAction: 'interactive_article_click',
                                        interactiveArticleLabel: q.des2
                                    });
                                    document.querySelector('#interactive-article-' + (idx + 1) + ' .img1').classList.add('fade');
                                    document.querySelector('#interactive-article-' + (idx + 1) + ' .message-box').classList.add('fade');

                                    setTimeout(() => {
                                        document.querySelector('#interactive-article-' + (idx + 1) + ' .message').innerHTML = '多謝你的意見!';
                                        document.querySelector('#interactive-article-' + (idx + 1) + ' .message-box').classList.remove('fade');
                                    }, 200)

                                    this.setState({answerClicked: true});
                                    setTimeout(() => {
                                        document.getElementById('interactive-article-' + (idx + 1)).classList.add('closed');
                                    }, 2000)
                                } else if (!this.state.answerClicked) {
                                    dataLayer.push({
                                        event: 'interactive-article-click',
                                        interactiveArticleAction: 'interactive_article_click',
                                        interactiveArticleLabel: q.url2
                                    })
                                }
                            }}>
                                <a target={q.url2 ? '_blank' : ''}
                                   href={q.url2 ? q.url2 + '?utm_source=' + that.getUTMSource(theme) + '&utm_medium=referral&utm_campaign=interactive_article&utm_term=beauty&utm_content=' + title : 'javascript:;'}>
                                    <img src={'/assets/img/' + q.img2}/>
                                    <div className="des">{q.des2}</div>
                                </a>
                            </div>
                        </div>
                        , document.getElementById('interactive-article-' + (idx + 1)))
                }

            }
        })
        return tmp;
    }

    linkInteractions(url,type){
        if(dataLayer)
            dataLayer.push({event: 'linksection', virtualPageURL: url+'exp', linkSection: type});
    }

    getUTMSource(theme){
        if (theme == 'she.com') {
            return 'shecom'
        } else if (theme == 'facelift.she.com') {
            return 'facelift'
        }else if (theme == 'shemom.com'){
            return 'shemom'
        } else if (theme == 'brides.she.com') {
            return 'shebrides'
        } else if (theme == 'luxshery.com') {
            return 'luxshery'
        } else if (theme == 'k.she.com') {
            return 'kchannel'
        } else {
            return theme
        }
    }

    getTags(data){
        let that = this;

        if (this.state.tagList && this.state.tagList.length) {
            // console.log('tags already existed');
        } else if (data.length) {
            that.setState({tagList: data});
            // console.log('get tags from tagDataset : ', that.state.tagList);
        } else {
            fetch('/wp-json/she-rest-api/getHottestTags/', {
                method: "GET",
            }).then(function (res) {
                return res.json();
            }).then(function (response) {
                let arr = response.items.tags;
                that.setState({tagList: arr});
                // console.log('get tags from API : ', that.state.tagList);
            }).catch(function (error) {
                console.log(error);
            });
        }
    }

    render(){
        //console.log(this);
        const { tagList, dataList } = this.state
        const { theme, section } = this.props
        let isMobile = this.isMobile;

        let that = this;
        const catid= document.querySelector('meta[name="catId"]').content;
        const site= document.querySelector('meta[name="baseURL"]').content;
        const listItems = dataList.map( function(dataListItem, index){

            return (
                <div key={index} id={"article-content-detail"+index} className="article-content-detail clearfix" >
                    <div className="content-left Abel" >
                        {
                            ( section=='she-promotes' ?
                                <div class="content-thumb">
                                    <img src={dataListItem.thumbnail_mobile} width="100%"/>
                                </div> :
                                '')
                        }
                        <div className="content-title">
                            { dataListItem.format=='video' ?  <span className="play-icon"><i className="icon-play-01"></i></span> : '' }
                            <a href={dataListItem.url}><h1 dangerouslySetInnerHTML={{ __html:dataListItem.post_title }}></h1></a>
                        </div>
                        <div className="content-info">
                            <ol className="info-list">
                                {
                                    (
                                        dataListItem.hasOwnProperty('author_pic') ?
                                            <li>
                                                <div className="thumb-author_pic" style={{backgroundImage:'url('+dataListItem.author_pic+')'}}>
                                                    <a href={dataListItem.author_url}>
                                                    </a>
                                                </div>
                                            </li> :
                                            ''
                                    )
                                }
                                <li className="category_name"><a href={'/'+dataListItem.category_name}  style={{ color:dataListItem.category_color }} dangerouslySetInnerHTML={{ __html:dataListItem.category_name }}></a></li>
                                <li>by <a href={dataListItem.author_url}>{ dataListItem.author_name } </a></li>
                                <li> { dataListItem.post_date.substr(0, 10) } </li>
                                <li className="fbsave-box">
                                    <div id="share-box">
                                        <button id="fb-desktop-share" className="share-icon" onClick={that.shareURL}><i className="icon-icon-facebook-1 fb-icon"></i></button>
                                        <button id="weibo-desktop-share" className="share-icon" onClick={that.shareURL}><i className="icon-weibo-1 weibo-icon"></i></button>
                                        <button id="whatsapp-desktop-share" className="share-icon" onClick={that.shareURL}><i className="icon-whatsapp-1 whatsapp-icon"></i></button>
                                        <button id="copylink-desktop-share" className="share-icon" onClick={that.shareURL}><i className="icon-link-1 link-icon"></i></button>
                                    </div>
                                </li>
                            </ol>
                        </div>
                        <div className="content-detail expand" data-author={ dataListItem.author_name }>
                            <div dangerouslySetInnerHTML={{
                                __html:that.renderHtml(dataListItem)
                            }}></div>

                            <div className="tag-link"  style={{ display:( dataListItem.hasOwnProperty('tags') && dataListItem.tags.length ? 'block' : 'none') }}>
                                {
                                    (
                                        dataListItem.hasOwnProperty('tags') ?
                                            dataListItem.tags.map(function(tagItem,tagIdx){
                                                return (
                                                    <a href={'/tag/'+tagItem.slug} rel="tag">{tagItem.name}</a>
                                                )
                                            }) :
                                            ''
                                    )
                                }
                            </div>
                            {/*{(theme == 'luxshery.com' || theme == 'facelift.she.com' || theme == 'brides.she.com' || theme == 'k.she.com' || theme == 'shemom.com') ?*/}
                            {
                                !((catid == 7287&&site=='https://www.shemom.com')||((catid==7289 || catid==7339 || catid==7338)&&site=='https://www.shemom.com')) ?

                                    <div id="inread-ads">
                                        <div className="ad_1x1 text-center">
                                            <Dfp
                                                dfpReady={that.dfpReady}
                                                dfpUpdate={that.dfpUpdate}
                                                adUnit={theme + "_inread_ATF_1x1"}
                                                // adUnit={ 'luxshery.com'+"_inread_ATF_1x1" }
                                                sizes={[[1, 1]]}
                                                sizeMapping={[
                                                    {viewport: [1, 1], sizes: [[1, 1]]},
                                                ]}
                                            />
                                        </div>
                                    </div>:''
                            }
                            {!isMobile?
                                <div className="related-article-block" style={{ display:( dataListItem.hasOwnProperty('related_article') && dataListItem.related_article.length ? 'block' : 'none') }}>
                                    <h2 className="related-section-title Abel" >related article</h2>
                                    <div className="clearfix">
                                        <div className="grid-article-content">
                                            {
                                                (
                                                    dataListItem.hasOwnProperty('related_article') ?
                                                        dataListItem.related_article.map(function(relatedItem, relatedIdx){
                                                            return (

                                                                <div class="grid-article-list">
                                                                    <div class="grid-article">
                                                                        <a href={relatedItem.url+'?utm_source=' + that.getUTMSource(theme) + '&utm_medium=referral&utm_campaign=related_article&utm_term=' + dataListItem.category_name + '&utm_content=' + dataListItem.post_title} target={relatedItem.target} title={relatedItem.post_title} onClick={ () => that.linkInteractions(relatedItem.url,'A/RA')}>
                                                                            <div class="thumb-img-container">
                                                                                <img class="thumb-img-cell" src={relatedItem.thumbnail_mobile} alt={relatedItem.post_title}/>
                                                                            </div>
                                                                        </a>
                                                                        <div class="desc-grid-article Abel">
                                                                            <div class="clearfix">
                                                                            </div>
                                                                            <a href={relatedItem.url+'?utm_source=' + that.getUTMSource(theme) + '&utm_medium=referral&utm_campaign=related_article&utm_term=' + dataListItem.category_name + '&utm_content=' + dataListItem.post_title} target={relatedItem.target} title={relatedItem.post_title} onClick={ () => that.linkInteractions(relatedItem.url,'A/RA')}>
                                                                                <div class="grid-article-title" >
                                                                                    <div class="grid-article-title-block"> {relatedItem.post_title} </div>
                                                                                </div>
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        }) :
                                                        ''
                                                )
                                            }</div>
                                    </div>
                                </div>:
                                <div className="related-article-block" style={{ display:( dataListItem.hasOwnProperty('related_article') && dataListItem.related_article.length ? 'block' : 'none') }}>
                                    <h2 className="related-section-title-m Abel" >related article</h2>
                                    <div className="clearfix">
                                        {
                                            (
                                                dataListItem.hasOwnProperty('related_article') ?
                                                    dataListItem.related_article.map(function(relatedItem, relatedIdx){
                                                        return (
                                                            <div className="grid-article">
                                                                <div className="desc-grid-article-title" >
                                                                    <a href={relatedItem.url} target={relatedItem.target} title={relatedItem.post_title}
                                                                       dangerouslySetInnerHTML={{ __html:relatedItem.post_title }} onClick={ () => that.linkInteractions(relatedItem.url,'A/RA')}></a>
                                                                </div>
                                                            </div>
                                                        )
                                                    }) :
                                                    ''
                                            )
                                        }
                                    </div>
                                </div>
                            }
                            <div className="like-article-block" style={{ display:( dataListItem.hasOwnProperty('you_may_also_like') && dataListItem.you_may_also_like.length ? 'block' : 'none' ) }}>
                                <h2 className="text-center Raleway highlights">
                                    <span>you may also like</span>
                                </h2>
                                <div className="clearfix">
                                    {
                                        (
                                            dataListItem.hasOwnProperty('you_may_also_like') ?
                                                dataListItem.you_may_also_like.map(function(likeItem, likeIdx){
                                                    return (
                                                        <div className="grid-article">
                                                            <div className="desc-grid-article-title" >
                                                                <a href={likeItem.url} target={likeItem.target} title={likeItem.post_title}  onClick={ () => that.linkInteractions(likeItem.url,'A/YMAL')}>
                                                                    <div className="thumb-img-cell" style={{ backgroundImage:'url('+likeItem.thumbnail_mobile+')'}} ></div>
                                                                    <div className="thumb-title-cell" dangerouslySetInnerHTML={{ __html:likeItem.post_title }} ></div>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    )
                                                }) :
                                                ''
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                        {/*<div className="content-more text-center" >*/}
                        {/*<div className="btn-content-more" onClick={(e) => that.expandContent(e, dataListItem.author_name)}></div>*/}
                        {/*</div>*/}
                    </div>
                    {
                        (catid == 7287&&site=='https://www.shemom.com') ?

                            <div className="content-right">
                                <div id="article-ads-lrec">
                                    <div className="ad_300x250 text-center">
                                        <div className={isMobile? "popular-tag-mobile":"popular-tag-desktop"}>
                                            <TopTags theme={theme} page={that.pagePlacement} position={'side'} catName={that.parentCategory} tagList={tagList} />
                                        </div>
                                        <Dfp
                                            dfpReady={that.dfpReady}
                                            dfpUpdate={that.dfpUpdate}
                                            adUnit={ theme+"_article_NestleMom_300x250" }
                                            // adUnit={ "she.com_article_ATF_300x250" }
                                            sizes={[[300,250],[300,600]]}
                                        />
                                    </div>
                                </div>
                            </div>:''
                    }
                    {
                        ((catid==7289 || catid==7339 || catid==7338)&&site=='https://www.shemom.com') ?

                            <div className="content-right">
                                <div id="article-ads-lrec">
                                    <div className="ad_300x250 text-center">
                                        <div className={isMobile? "popular-tag-mobile":"popular-tag-desktop"}>
                                            <TopTags theme={theme} page={that.pagePlacement} position={'side'} catName={that.parentCategory} tagList={tagList} />
                                        </div>
                                        <Dfp
                                            dfpReady={that.dfpReady}
                                            dfpUpdate={that.dfpUpdate}
                                            adUnit={ theme+"_article_NestleBB_300x250" }
                                            // adUnit={ "she.com_article_ATF_300x250" }
                                            sizes={[[300,250],[300,600]]}
                                        />
                                    </div>
                                </div>
                            </div>:''
                    }
                    {
                        !((catid == 7287&&site=='https://www.shemom.com')||((catid==7289 || catid==7339 || catid==7338)&&site=='https://www.shemom.com')) ?

                            <div className="content-right">
                                <div id="article-ads-lrec">
                                    <div className="ad_300x250 text-center">
                                        <div className={isMobile? "popular-tag-mobile":"popular-tag-desktop"}>
                                            <TopTags theme={theme} page={that.pagePlacement} position={'side'} catName={that.parentCategory} tagList={tagList} />
                                        </div>
                                        <Dfp
                                            dfpReady={that.dfpReady}
                                            dfpUpdate={that.dfpUpdate}
                                            adUnit={ theme+"_article_ATF_300x250" }
                                            // adUnit={ "she.com_article_ATF_300x250" }
                                            sizes={[[300,250],[300,600]]}
                                        />
                                    </div>
                                </div>
                            </div>:''
                    }

                </div>
            )
        });

        return (
            <div>
                {listItems}
            </div>
        )
    }
}

export default Article;



// WEBPACK FOOTER //
// ./src/Article.js